<template>
  <section id="about-contact-info">
    <SectionTitle class="!items-start" title="Contacts" />
    <div class="grid grid-cols-1 md:grid-cols-3 gap-5">
      <CardWrapper :title="$t('landing.contact_info.dubai_head_office')">
        <a
          href="https://www.google.com/maps?q=25.18822,55.25836"
          target="_blank"
          class="text-lg text-dark font-medium font-openSans"
        >
          {{ $t("landing.contact_info.dubai_head_office_address") }}
        </a>
      </CardWrapper>
    </div>
    <RouterLink
      to="/contact-us"
      class="flex-y-center gap-1 mt-10 text-green-700 font-medium group"
    >
      <span>{{ $t("landing.contact_info.learn_more") }}</span>
      <span class="icon-right group-hover:translate-x-2 transition-300" />
    </RouterLink>
  </section>
</template>

<script setup lang="ts">
import SectionTitle from "@/modules/Landing/components/Common/SectionTitle.vue";
import CardWrapper from "@/modules/Landing/components/Card/Wrapper.vue";
</script>

<style scoped></style>
